//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class NoticeStatusService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[NoticeStatus.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/notification/notice-status/detail', {'params':params});
	};

	//GeneratorFlag:[NoticeStatus.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/notification/notice-status/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}